// extracted by mini-css-extract-plugin
module.exports = {" _key":"dojo2-todo-mvc-kitchensink/themeSwitcher","themeSwitcher":"themeSwitcher-m__themeSwitcher__3Nioq","themeSwitcherCheckbox":"themeSwitcher-m__themeSwitcherCheckbox__3hY7s"};